// geo.service.ts
import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class GeoService {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  async isRegulatedRegion(): Promise<boolean> {
    // Only run geo lookup in browser
    if (!isPlatformBrowser(this.platformId)) {
      return true; // Default to regulated for SSR
    }

    try {
      const res = await fetch('https://ipapi.co/json/');
      const data = await res.json();
      const regulatedCountries = ['DE', 'FR', 'IT', 'ES', 'NL', 'SE', 'PL', 'BE', 'DK', 'FI', 'PT', 'RO', 'IE', 'CZ', 'HU', 'SK', 'AT', 'GR', 'BG', 'HR', 'SI', 'EE', 'LV', 'LT', 'LU', 'CY', 'MT'];
      const isEU = regulatedCountries.includes(data.country_code);
      const isCalifornia = data.region_code === 'CA' && data.country_code === 'US';
      return isEU || isCalifornia;
    } catch (e) {
      console.warn('Geo lookup failed', e);
      return true; // safest fallback
    }
  }
}
